<script>
  export default {
    props: ['piece'],

    computed: {
      facebook () {
        return 'https://www.facebook.com/sharer/sharer.php?u=' + this.piece.share
      },

      twitter () {
        return 'https://twitter.com/intent/tweet?url=' + this.piece.share
      }
    }
  }
</script>

<template>
  <div class="social">
    <span class="icon"><a :href="twitter" target="_blank"><i class="fa fa-twitter"></i></a></span>
    <span class="icon"><a :href="facebook" target="_blank"><i class="fa fa-facebook"></i></a></span>
  </div>
</template>

<style lang="scss" scoped>
  .social {
    text-align: right;
  }

  a {
    color: white;
  }
</style>



// WEBPACK FOOTER //
// partials/HubShare.vue